export default __webpack_public_path__ + "static/media/resource-desk-featured-image-placeholder.355b95bd.svg";